function GetSitekey() {

    if (window.sitekey) {
      return window.sitekey;
    }
    }
export default GetSitekey;